var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.484 6.31295L9.15067 2.14628C8.86317 1.78628 8.33817 1.72878 7.97984 2.01628C7.61984 2.30295 7.5615 2.82795 7.849 3.18711L10.0998 6.00045H2.6665C2.20734 6.00045 1.83317 5.62628 1.83317 5.16711V1.00045C1.83317 0.539614 1.45984 0.167114 0.999837 0.167114C0.539837 0.167114 0.166504 0.539614 0.166504 1.00045V5.16711C0.166504 6.54545 1.28817 7.66711 2.6665 7.66711H10.0998L7.849 10.4796C7.5615 10.8388 7.61984 11.3638 7.97984 11.6504C8.13317 11.7738 8.31734 11.8338 8.49984 11.8338C8.744 11.8338 8.9865 11.7263 9.15067 11.5204L12.484 7.35378C12.7273 7.04961 12.7273 6.61711 12.484 6.31295Z",
    fill: "#1F7A34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/Reply.059c7c5c6246b49079772d30dd6f0c30.svg";
export { ForwardRef as ReactComponent };